import Cookies from 'js-cookie';
import { COOKIE_NAME_USER_LANGUAGE } from '../constants/common'

export default () => {
  const linkNodes = document.querySelectorAll('[data-switcher="language"]');
  if (!linkNodes.length) return;

  [].forEach.call(linkNodes, (node) => {
    node.addEventListener('click', (event) => {
      event.preventDefault();

      Cookies.set(COOKIE_NAME_USER_LANGUAGE, node.dataset.altLanguage, {
        domain: window.commonCookieDomain,
        expires: 365,
      });

      window.location.replace(node.href);
    });
  });
};
